export const redirectToReportSignIn = (
  { pathname, search }: { pathname: string; search: string },
  history: { push: (path: string) => void },
): void => {
  if (new URLSearchParams(search).has('range')) {
    sessionStorage.setItem('reportReturnPath', `${pathname}${search}`);
  }
  history.push('/signin');
};
